export function getAvailableFlagPaths() {
  const availableFlagPaths = (ctx => {
    const keys = ctx.keys();

    return keys.map(fileName => {
      const file = fileName.replace(/^.*[\\/]/, '');

      const [country] = file.split('.');

      return country;
    });
  })(require.context('@/assets/flags/', false, /\.svg$/));

  return availableFlagPaths;
}
